import { render, staticRenderFns } from "./CardIndicatorInfoGenderGap.vue?vue&type=template&id=558ebd77&scoped=true&"
import script from "./CardIndicatorInfoGenderGap.vue?vue&type=script&lang=js&"
export * from "./CardIndicatorInfoGenderGap.vue?vue&type=script&lang=js&"
import style0 from "./CardIndicatorInfoGenderGap.vue?vue&type=style&index=0&id=558ebd77&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "558ebd77",
  null
  
)

export default component.exports